import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { HTMLAttributes } from 'react';

const badgeVariants = cva(
  'inline-flex items-center justify-center items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground shadow',
        neutral: 'border-transparent bg-blue-100 text-blue-700',
        outline: 'text-foreground',
        success: 'border-transparent bg-[#25D366] text-white',
        warning: 'border-transparent bg-[#FFB237] text-white',
        successOutline: 'border-transparent bg-[#DCFCE7] text-[#22C55E]',
        warningOutline: 'border-transparent bg-orange-50 text-orange-500',
        errorOutline: 'border-transparent bg-[#FEE2E2] text-[#EF4444]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

type BadgeVariants = typeof badgeVariants;

type BadgeProps = HTMLAttributes<HTMLDivElement> & VariantProps<BadgeVariants>;

const Badge = ({ className, variant, ...props }: BadgeProps) => (
  <div className={cn(badgeVariants({ variant }), className)} {...props} />
);

export { Badge, badgeVariants };
export type { BadgeProps, BadgeVariants };
